import { ClipProvider } from '@/@types/graphql-types';
import { TrailerClip } from '@/interfaces/trailerClip';

export function getTrailerComponent(provider: TrailerClip['provider']) {
	switch (provider) {
		case ClipProvider.Videobuster:
			return () =>
				import(/* webpackChunkName: "videobuster-player" */ '@/ui-components/players/VideobusterPlayer.vue');
		case ClipProvider.Dailymotion:
		case 'JUSTWATCH_TV':
		case 'OTT':
			return () =>
				import(/* webpackChunkName: "dailymotion-player" */ '@/ui-components/players/DailyMotionPlayer.vue');
		case 'PLEX':
			return () => import(/* webpackChunkName: "plex-player" */ '@/ui-components/players/PlexPlayer.vue');

		default:
			return () => import(/* webpackChunkName: "youtube-player" */ '@/ui-components/YoutubePlayer.vue');
	}
}

export function isBitMovinCountry(country: string): boolean {
	// keeping this function for future use, in case we want to limit bitmovin usage again
	return true;
	// return ['FR', 'UK', 'DE', 'ES', 'IT', 'TR', 'IN'].includes(country);
}
